// axiosConfig.js
import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api/", // Default to local if the environment variable is not set
});

// Request interceptor to add the Authorization header to every request
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Response interceptor to handle 401 errors and refresh the token
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            // Don't try refresh for login/register - 401 means bad credentials; let the form show the error
            const url = originalRequest.url || '';
            if (url.includes('/login') || url.includes('/register')) {
                return Promise.reject(error);
            }

            originalRequest._retry = true;

            try {
                // Get refresh token from localStorage
                const refreshToken = localStorage.getItem("refreshToken");

                // Request a new access token using the refresh token
                const response = await axios.post(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api/"}refresh/`, {
                    refresh: refreshToken,
                });

                const newAccessToken = response.data.access;

                // Store the new token
                localStorage.setItem("authToken", newAccessToken);

                // Update the original request Authorization header with the new token
                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

                // Retry the original request with the new token
                return api(originalRequest);
            } catch (refreshError) {
                // If refreshing fails, log out the user
                console.error("Token refresh failed:", refreshError);
                localStorage.removeItem("authToken");
                localStorage.removeItem("refreshToken");
                window.location.href = "/login";  // Redirect to login if token refresh fails
            }
        }
        return Promise.reject(error);
    }
);

export default api;
